module.exports = {
  container: {
    title: 'Platform infrastruktur Web3 yang ringan, terbuka dan selamat',
    content:
      'BitFlow bertujuan untuk membina infrastruktur blockchain yang stabil, boleh dipercayai dan selamat, mengagregat nod rantaian awam arus perdana merentas rangkaian, menyediakan perkhidmatan ikrar LSD yang mudah, dan mengekalkan kestabilan dan kecairan aset digital.',
    info: 'Rangkaian: 10+ Rakan Kongsi: 20+ Pengguna Komuniti: 20000+',
    button: 'Ikrar sekarang',
  },
  intro: {
    title: 'Fungsi Teras BitFlow',
    coinTitle1: 'Pertaruhan bukan jagaan',
    coinContent1:
      'Melalui nod terdesentralisasi, aset pengguna disimpan dalam dompet pengguna sendiri, dan BitFlow hanya menyimpan kunci pengesahan dan tidak akan menyentuh kunci pengeluaran pengguna.',
    coinTitle2: 'Ikrar kecairan',
    coinContent2:
      'Menyediakan perkhidmatan pertaruhan kecairan yang selamat dan mudah, gunakan oracle polimorfik untuk mendapatkan kecairan daripada DEX utama, dan mengekalkan kestabilan harga',
    coinTitle3: 'LSO',
    coinContent3:
      'Pledge adalah perlombongan, model pembiayaan token baharu, pengguna hanya perlu mencagarkan token untuk mengunci platform untuk mendapatkan pendapatan perlombongan.',
  },
  advantage: {
    title: 'Sorotan BitFlow',
    title2: 'Menyediakan perkhidmatan ikrar LSD yang selamat, cekap dan boleh dipercayai',
    content:
      'BitFlow membina ekosistem berbilang rantaian yang lebih kolaboratif dan berkuasa melalui infrastruktur nod teragih global, sebagai lapisan asas Web3, DeFi dan kewangan yang disulitkan, yang membolehkan pengguna mengambil bahagian dalam perkhidmatan ikrar LSD dalam pengurusan automatik yang tersebar risiko, dan cara yang cekap , menghubungkan dunia melalui aset digital, dan mencipta era baharu aplikasi ekologi digital.',
  },
  more: {
    title: 'Model inovatif, cekap dan mudah',
    content:
      'BitFlow membolehkan pengguna menggunakan token yang dipertaruhkan untuk mengakses dan meneroka aplikasi Web3 bersepadu BitFlow dan perkhidmatan DeFi.',
    button: 'Belajar lebih',
    boxTitle1: 'Ikrar berbilang rantai',
    boxContent1:
      'Rangkaian awam koperasi semasa termasuk ETH, BNB, Polygon, ARB, SUI, dsb., dan lebih banyak rangkaian akan disokong pada masa hadapan.',
    boxTitle2: 'Terdesentralisasi',
    boxContent2:
      'Pengguna ikrar dan pengendali nod dipadankan secara bebas, dan penciptaan, penarikan balik dan delegasi ganjaran semuanya dikendalikan oleh kontrak pintar di lapisan pelaksanaan.',
    boxTitle3: 'Pengurusan nod',
    boxContent3:
      'Sokong pengguna untuk menggunakan pengesah mereka sendiri untuk pengurusan nod, menyediakan sokongan perkhidmatan awan dan menjimatkan masa penyegerakan.',
    boxTitle4: 'Sekat pemantauan',
    boxContent4:
      'BitFlow memantau semua nod dan perkhidmatan API dalam masa nyata sepanjang masa, dan mempersembahkan data yang lebih komprehensif dan intuitif kepada pengguna.',
    boxTitle5: 'Pendapatan kompaun',
    boxContent5:
      'Untuk melepaskan kecairan aset digital, pengguna boleh memperoleh pelbagai faedah daripada pertaruhan, perlombongan kecairan dan rebat jemputan.',
  },
  ecology: {
    title: 'Ekosistem BitFlow Mengikrarkan Masa Depan',
    content: 'Terokai senario aplikasi Web3 dan perkhidmatan DeFi',
  },
  media: 'Rakan kongsi global',
  bitFlowIntro: {
    content:
      'Model ekonomi token sempurna pertama di dunia bagi mekanisme gerakan kekal lingkaran terdesentralisasi, mewujudkan platform infrastruktur web3 terdesentralisasi dan teragih terkuat untuk menghasilkan mesin tunai yang mampan.',
  },
  transaction: {
    wallet: 'Log masuk dompet',
    assets: {
      title: 'kuasa pengkomputeran saya',
      content: 'kuasa pengkomputeran saya',
      text1: 'Deposit',
      text2: 'Perdagangan',
      text3: 'Pemindahan',
      text4: 'Penggantian',
      text5: 'Aset',
    },
    place: {
      tab1: 'Membuat pesanan',
      tab2: 'Mengundi semula',
      text1: 'Baki USDT',
      text2: 'Imbangan aliran',
      mask: 'Anda belum mengikat dompet peringkat atas dan tidak boleh membuat pesanan.',
      maskLight: 'Adakah anda mahu mengikat serta-merta?',
      payNeed: 'Bayaran diperlukan',
      confirm: 'Mengesahkan pesanan',
      contact: 'Hubungi Kami',
      maskInputTitle: 'Pautkan akaun',
      maskInputContent: 'Hanya apabila akaun yang sah dipautkan, pautan itu boleh berjaya',
      placeholder: 'Sila masukkan akaun terpaut yang sah',
      confirmLink: 'Sahkan pautan',
    },
  },
}
